// extracted by mini-css-extract-plugin
export default {"period":"period_period__bx2RE","listedBlocks":"period_listedBlocks__hIqjf","blocks":"period_blocks__qCwk6","gridDisplay":"period_gridDisplay__lv9ZM"};